import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgRoundedPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	viewBox: "3 3 10 10",
	fill: "none",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		d: "M8.5 4a.5.5 0 1 0-1 0v3.5H4a.5.5 0 1 0 0 1h3.5V12a.5.5 0 1 0 1 0V8.5H12a.5.5 0 1 0 0-1H8.5V4z",
		fill: "#1cb954"
	})
});
export default SvgRoundedPlus;
